module.exports = __webpack_public_path__ + "static/media/amazon.00b9ce42.png";